import { computed } from 'vue';

export const useCapiEventValue = (selected, value, supportsValue) => {
  const requiresValue = computed(() => selected.value === 'Purchase');
  const hasValue = computed(
    () => value.value !== null && String(value.value).trim() !== ''
  );
  const invalidValue = computed(
    () =>
      requiresValue.value &&
      (!hasValue.value ||
        !Number.isFinite(Number(value.value)) ||
        Number(value.value) < 0)
  );
  const valueParams = computed(() =>
    supportsValue.value && hasValue.value ? { value: value.value } : {}
  );

  return { requiresValue, invalidValue, valueParams };
};
